var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8711 11H13.8711V1C13.8711 0.734784 13.7657 0.48043 13.5782 0.292893C13.3907 0.105357 13.1363 0 12.8711 0C12.6059 0 12.3515 0.105357 12.164 0.292893C11.9765 0.48043 11.8711 0.734784 11.8711 1V11H1.87109C1.60588 11 1.35152 11.1054 1.16399 11.2929C0.976451 11.4804 0.871094 11.7348 0.871094 12C0.871094 12.2652 0.976451 12.5196 1.16399 12.7071C1.35152 12.8946 1.60588 13 1.87109 13H11.8711V23C11.8711 23.2652 11.9765 23.5196 12.164 23.7071C12.3515 23.8946 12.6059 24 12.8711 24C13.1363 24 13.3907 23.8946 13.5782 23.7071C13.7657 23.5196 13.8711 23.2652 13.8711 23V13H23.8711C24.1363 13 24.3907 12.8946 24.5782 12.7071C24.7657 12.5196 24.8711 12.2652 24.8711 12C24.8711 11.7348 24.7657 11.4804 24.5782 11.2929C24.3907 11.1054 24.1363 11 23.8711 11Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.84302ac5e2b5eb8c3d8de6927d16f975.svg";
export { ForwardRef as ReactComponent };